import { MaterialIcon } from '@koolumbus/web/ui';
import clsx from 'clsx';
import React from 'react';
import { Marker } from 'react-map-gl';

interface MapMarkerProps {
  latitude: number;
  longitude: number;
  onSelect?: () => void;
  selected: boolean;
  price?: number;
}

const MapMarker: React.FC<React.PropsWithChildren<MapMarkerProps>> = ({
  latitude,
  longitude,
  onSelect,
  selected,
  price,
}) => {
  const hasPrice = typeof price !== 'undefined';

  return (
    <Marker latitude={latitude} longitude={longitude} className={clsx(selected && 'z-10')}>
      <div
        onClick={onSelect}
        className={clsx(
          'flex-center rounded-full border-1 border-gray-200 shadow-md hover:shadow-lg cursor-pointer hover:scale-110 transition-all',
          selected ? 'bg-primary text-white scale-110' : 'bg-white text-primary',
          hasPrice ? 'h-7 px-2' : 'h-8 w-8',
        )}
      >
        {hasPrice ? (
          <span className="font-medium text-sm">€ {price?.toLocaleString()}</span>
        ) : (
          <MaterialIcon
            icon="home"
            className={clsx(selected ? 'text-white' : 'text-primary-500')}
            style={{ fontSize: 22 }}
          />
        )}
      </div>
    </Marker>
  );
};

export default MapMarker;
